import { Dispatch, SetStateAction } from 'react';
import { useResumeSearchAlerts } from '@hooks/filters/useResumeSearchAlerts';
import { useTranslation } from 'next-i18next';
import { Button, Tooltip } from '@components/common';
import { ClockRotateLeftIcon } from '@components/common/Icons';
import { i18nConfig } from 'i18n-config';
import { filterStyles } from '../helpers/filterStyles';


// Interface
// ******************************************
interface TopBarSearchAlertsProps {
  locale?: Locale,
  setQueryParams: Dispatch<SetStateAction<object>>,
}


/**
 * @description Renders the resume search alerts in top-bar filters. On click, it sets the selected filters.
 * - **locale** The locale of the app
 * - **setQueryParams** The set query params function (get it from parent)
 */
export const TopBarSearchAlerts = (props: TopBarSearchAlertsProps) => {
  // Destructure props
  const {
    locale = i18nConfig.defaultLocale,
    setQueryParams,
  } = props;

  // Translation
  const { t } = useTranslation('common');


  // Resume search alerts hook
  // ******************************
  const {
    searchAlerts,
    setSelectedFilters,
  } = useResumeSearchAlerts({ locale, sortQueryParams: true });


  // Render component
  // ******************************
  return (
    <>
      {
        searchAlerts?.map((alert) => (
          <Tooltip
            floating
            key={alert?.id}
            position="bottom"
            className="block"
            contentSizeClass={filterStyles.suggestionTooltip}
            tooltipText={(
              <>
                <span className="mb-1 block border-b border-dashed border-input/70 pb-1">{t('user.saved.apply.search')}</span>
                <span className="block text-ink">{alert?.label}</span>
              </>
            )}
          >
            <Button
              styling="none"
              onClick={() => setSelectedFilters(alert?.resumeSearch, setQueryParams)}
              className={filterStyles.suggestionButton}
            >
              <ClockRotateLeftIcon className={`${filterStyles.suggestionButtonIcon} size-4.5`} />
              <span className="block truncate">{alert?.label}</span>
            </Button>
          </Tooltip>
        ))
      }
    </>
  );
};
